import { Icon } from "@captions-web/icons";
import { createFileRoute } from "@tanstack/react-router";
import { t } from "i18next";

import { LayoutBleed } from "~/components/layouts/bleed";
import { ActorLibraryGrid } from "~/modules/actors/components/actor-library-grid";
import { CreateActorFromMedia } from "~/modules/actors/components/create-actor";
import { getAllPossibleActorQueryParams } from "~/modules/actors/constants/filters";
import { listActorsQuery } from "~/modules/actors/network/queries";
import { css } from "~/styled-system/css";

export const Route = createFileRoute("/_app/actors")({
  component: RouteComponent,
  loader({ context: { queryClient } }) {
    getAllPossibleActorQueryParams().forEach((params) => {
      queryClient.prefetchInfiniteQuery(listActorsQuery.queryOptions({ params }));
    });
  },
});

function RouteComponent() {
  return (
    <LayoutBleed
      leftActions={
        <h1
          className={css({
            display: "flex",
            gap: "16px",
            textStyle: "heading-5",
            color: "$gray.200",
          })}
        >
          <Icon name="person" size={24} className={css({ color: "$gray.500" })} />
          {t("mirage-studio:actors.page-title")}
        </h1>
      }
      rightActions={<CreateActorFromMedia triggerStyle="md" />}
    >
      <div className={containerStyles}>
        <ActorLibraryGrid placement="page" />
        {/* hiding for now until we have both the media and text image generation working */}
        {/* <div className={boxContainerStyles}>
          <div className={createBoxStyles}>
            <CreateActorFromMedia onCreatedActor={() => Promise.resolve()} />
            <CreateActorFromText onCreateAuditionFromActorPrompt={() => Promise.resolve()} />
          </div>
        </div> */}
      </div>
    </LayoutBleed>
  );
}

const containerStyles = css({
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden",
});

const boxContainerStyles = css({
  position: "absolute",
  bottom: 0,
  zIndex: "$centerFixedBox",
  display: "flex",
  justifyContent: "center",
  width: "100%",
  padding: "124px 0 12px",

  pointerEvents: "none",
  borderBottomRadius: "24px",
  background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%)",
});

const createBoxStyles = css({
  layerStyle: "blur-lg",

  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "6px",
  padding: "12px",

  borderRadius: "24px",
  pointerEvents: "auto",
});
